


































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { downloadPromise } from '@/helpers/download';
import generateSignedUrl from '@/helpers/generateSignedUrl';

type Status = 'loading' | 'downloadReady' | 'downloading' | 'error' | null;

@Component({
  name: 'Download',
})
export default class Download extends Vue {
  appName: string | null = null;
  appVersion: string | null = null;

  error: Error | null = null;
  status: Status = null;
  token: string | null = null;
  progress = 0;

  async mounted() {
    await this.getToken();
    await this.fetchData();
  }

  async getToken() {
    const token = await this.$auth.getTokenSilently({});
    this.token = token;
  }

  async fetchData() {
    const options = {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    };

    try {
      this.status = 'loading';
      this.progress = 20;

      const { data } = await this.$http.get<AppStore.SingleAppData>({
        url: `/?app=${this.$route.params.app}`,
        options,
      });

      this.progress = 40;

      const { releases } = data;

      if (!releases) {
        throw new Error('There are no files available for this application');
      }

      const matchingItem = releases.filter(
        (release) => release.version === this.$route.params.version,
      );

      if (!matchingItem.length) {
        throw new Error(`Version ${this.$route.params.version} does not exist on this app.`);
      }

      const { artifacts, display_name, version } = matchingItem[0];

      let signedUrl: string | null = null;

      if (this.$route.params.type === 'app') {
        signedUrl = generateSignedUrl(artifacts.app);
      } else if (this.$route.params.type === 'notes') {
        if (!artifacts.release_notes) {
          throw new Error('There are no release notes available for this version');
        }

        signedUrl = generateSignedUrl(artifacts.release_notes[1]);
      } else if (this.$route.params.type === 'manual') {
        if (!artifacts.user_manual) {
          throw new Error('There are no user manuals available for this version');
        }

        signedUrl = generateSignedUrl(artifacts.user_manual[1]);
      } else {
        throw new Error(`Malformed link. Link type '${this.$route.params.type}' is not supported`);
      }

      this.appName = display_name;
      this.appVersion = version;

      if (!signedUrl) {
        throw new Error('Invalid file');
      }

      await this.downloadFile(signedUrl);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      this.status = 'error';
      this.error = error;
    }
  }

  async downloadFile(url: string) {
    if (!url) {
      throw new Error('No signed download URL has been provided');
    }

    const options = {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    };

    try {
      const { data } = await axios.get(url, options);
      this.status = 'downloadReady';

      await downloadPromise(data, '');

      this.status = 'downloading';
      this.progress = 100;
    } catch (error) {
      // eslint-disable-next-line no-console
      this.status = 'error';
      this.error = error;
      console.error(error);
    }
  }
}
